module.exports = __webpack_public_path__ + "media/icons/naped-przod-unactive@2x-23614546.png";